import { DEVICE_STATUS, DEVICE_TYPE, InfraDevice } from '@/types/pages/storeManagement/registration/registrationTypes';

export const deriveInfraDeviceState = (infraDevice: InfraDevice[]) => {
    const hasAP = infraDevice.some((item) => item.device_type_id === DEVICE_TYPE.AP);
    const hasRT = infraDevice.some((item) => item.device_type_id === DEVICE_TYPE.RT);
    const hasTag = infraDevice.some((item) => item.device_type_id === DEVICE_TYPE.TAG);
    const hasApConfirmed = infraDevice.some(
        (item) => item.device_type_id === DEVICE_TYPE.AP && item.confirmed === DEVICE_STATUS.CONFIRMED,
    );
    const hasApUnlock = infraDevice.some(
        (item) =>
            item.device_type_id === DEVICE_TYPE.AP &&
            item.confirmed === DEVICE_STATUS.CONFIRMED &&
            item.network_mode === 'UNLOCK',
    );
    const hasRTConfirmed = infraDevice.some(
        (item) => item.device_type_id === DEVICE_TYPE.RT && item.confirmed === DEVICE_STATUS.CONFIRMED,
    );

    const tagInfo = infraDevice.reduce(
        (acc, item) => {
            if (item.device_type_id === DEVICE_TYPE.TAG) {
                if (item.confirmed === DEVICE_STATUS.CONFIRMED) {
                    acc.confirmed++;
                } else {
                    acc.total++;
                }
            }
            return acc;
        },
        { confirmed: 0, total: 0 },
    );
    return { hasAP, hasRT, hasApConfirmed, hasApUnlock, hasRTConfirmed, hasTag, tagInfo };
};

export const deriveInfraTagState = (infraDevice: InfraDevice[]) => {
    const tagInfo = infraDevice.reduce(
        (acc, item) => {
            if (item.device_type_id === DEVICE_TYPE.TAG) {
                if (item.confirmed === DEVICE_STATUS.CONFIRMED) {
                    acc.confirmed++;
                }
                if (item.confirmed === DEVICE_STATUS.UN_CONFIRMED) {
                    acc.unconfirmed++;
                }
                acc.total++;
            }
            return acc;
        },
        { confirmed: 0, total: 0, unconfirmed: 0 },
    );
    const isAllUnConfirm = tagInfo.unconfirmed === tagInfo.total;
    const isOnProgress = tagInfo.confirmed !== tagInfo.total;
    const tagForRegisterList = infraDevice
        .filter((o) => o.device_type_id === DEVICE_TYPE.TAG && o.confirmed === DEVICE_STATUS.UN_CONFIRMED)
        .map((o) => o.mac);
    return {
        isOnProgress,
        tagInfo,
        isAllUnConfirm,
        tagForRegisterList,
    };
};
